<div class="p-field">
    <p-button [label]="label" styleClass="p-button-link"  (click)="handleClick($event)"></p-button>
</div>